import LText, { Props as LTextProps } from "@components/LText";
import { theme } from "@theme";
import SkeletonPlaceholder from "react-native-skeleton-placeholder";
import {
  LOADING_SHIMMER_SPEED,
  LOADING_SHIMMER_BG_COLOR,
  LOADING_SHIMMER_HIGHLIGHT_COLOR,
} from "../../config";

type TitleProps = {
  title: string;
} & Omit<LTextProps, "children">;

const Title = ({ title, ...props }: TitleProps) => {
  return (
    <LText variant="Display/D3/SemiBold" color="white" {...props}>
      {title}
    </LText>
  );
};

const Loading = () => {
  return (
    <SkeletonPlaceholder
      highlightColor={LOADING_SHIMMER_HIGHLIGHT_COLOR}
      backgroundColor={LOADING_SHIMMER_BG_COLOR}
      speed={LOADING_SHIMMER_SPEED}
      borderRadius={theme.borderRadii.max}
    >
      <SkeletonPlaceholder.Item
        width={"100%"}
        height={theme.textVariants["Display/D3/SemiBold"].lineHeight}
        borderRadius={theme.borderRadii.s}
      />
    </SkeletonPlaceholder>
  );
};

export default {
  Title,
  Loading,
};
